let accordions = document.querySelectorAll(".product-description .desc-head");
let tabsButton = document.querySelectorAll(
  ".description-heading .heading-button"
);
let tabs = document.querySelectorAll(".desc-block");
////////////////////Products deffered media toggler
let toggleButton = document.querySelectorAll(".media-toggle");
toggleButton.forEach(function (el, ind) {
  el.addEventListener("click", function () {
    let parent = el.closest(".product-media-container");
    let template = parent.querySelector("template");
    template ? parent.insertAdjacentHTML("beforeend", template.innerHTML) : "";
    parent.setAttribute("data-loaded", "true");
  });
});
////////////////////Product description toggle
accordions.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    let parent = el.closest(".desc-block");
    let iconChange = parent.querySelector(".desc-head-icon");
    console.log('the icon is ', iconChange)
    iconChange.innerHTML = '&#8722;';

    // Close all other accordions
      document.querySelectorAll(".product-description .desc-block.open").forEach(function (openBlock) {
        let iconReturn = openBlock.querySelector('.desc-head-icon')
        iconReturn.innerHTML = '&#43;'
        if (openBlock !== parent) {
          openBlock.classList.remove("open");
        }
      });
    parent.classList.toggle("open");
  });
});
///////////////////Tabs toggle
tabsButton.forEach(function (el, ind) {
  el.addEventListener("click", function () {
    let tabBtn = el;
    tabsButton.forEach((el,ind)=> el == tabBtn ? el.classList.add("active") : el.classList.remove("active"));
    let dataIndex = el.dataset.val;
    tabs.forEach((el, ind) => {
      if (el.dataset.id == dataIndex) {
        el.classList.add("active");
        el.classList.add("open");
      } else {
        el.classList.remove("active");
        el.classList.remove("open");
      }
    });
  });
});
